<template>
  <div>
    <el-backtop :bottom="topHieght" :visibility-height="50" :right="20" ref="backtop">
      <div class="to-top-div">
        <img :src="img" alt="置顶" class="to-top-img" />
      </div>
    </el-backtop>
  </div>

</template>

<script>
export default {
  data() {
    return {
      img: require("@/icons/svg/to_top.svg"),
    };
  },
  mounted(){
    console.log(this,'back');
  },
  computed:{
    topHieght() {
      return this.$route.name == "commentRecordDetail"? 230 : 100
    }
  }
};
</script>

<style>
.to-top-div {
  height: 100%;
  width: 100%;
  background-color: #f2f5f6;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  text-align: center;
  line-height: 40px;
  color: #ff7c2c;
  border-radius: 20px;
}
.to-top-img {
  height: 20px;
  width: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/EtmsBackTop/index.vue